<div
    class="footer-area text-center bg-white border-top-radius box-shadow"
    [class.card-borderd-theme]="themeService.isCardBorder()"
    [class.component-dark-theme]="themeService.isDark()"
    [class.card-border-radius]="themeService.isCardBorderRadius()"
>
    <p>© Atendimento - 190  (DiTel - Diretoria de Telemática) <a href="https://www.pmdf.df.gov.br/" class="fw-semibold" target="_blank">PMDF</a></p>
</div>